import * as React from "react";
import { Route, Switch } from "react-router-dom";
import StructuredProdScrn from "../../components/footer/structuredProduct/structuredProdScrn";
import { InfinityPlan } from "../../components/subscription/infinityPlan";
import GenericInsuranceScreen from "../../components/leadPages/genericInsurance/genericInsuranceScreen";

export interface IFooterRoutingProps {}

const FooterRouting: React.FC<IFooterRoutingProps> = () => {
	return (
		<Switch>
			<Route path="/structured-product" exact component={StructuredProdScrn} />
			<Route path="/generic-insurance" component={GenericInsuranceScreen} />
			<Route path="/infinity-plan" exact component={InfinityPlan} />
		</Switch>
	);
};

export default FooterRouting;
